import { render } from "./dinings.vue?vue&type=template&id=2d81a784&scoped=true"
const script = {}

import "./dinings.vue?vue&type=style&index=0&id=2d81a784&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d81a784"]])

export default __exports__